import { render, staticRenderFns } from "./DeviceService.vue?vue&type=template&id=ceeb813e&scoped=true"
import script from "./DeviceService.vue?vue&type=script&lang=js"
export * from "./DeviceService.vue?vue&type=script&lang=js"
import style0 from "./DeviceService.vue?vue&type=style&index=0&id=ceeb813e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceeb813e",
  null
  
)

export default component.exports